import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `
    <footer style="container-type: inline-size;">
      <div class="footer-content" aria-label="Footer navigation">
        <nav class="link-wrapper">
          <a
            class="syn-link syn-link--medium syn-link--quiet"
            href="https://www.sick.com/de/en/s/imprint"
            i18n="@@footer.imprint"
          >
            Imprint
          </a>
          <a
            class="syn-link syn-link--medium syn-link--quiet"
            href="https://www.sick.com/de/en/general-terms-and-conditions/w/tac/"
            i18n="@@footer.termsAndConditions"
          >
            Terms and Conditions
          </a>
          <a
            class="syn-link syn-link--medium syn-link--quiet"
            href="https://www.sick.com/de/en/s/terms-of-use"
            i18n="@@footer.termsOfUse"
          >
            Terms of Use
          </a>
          <a
            class="syn-link syn-link--medium syn-link--quiet"
            href="https://www.sick.com/de/en/sick-data-privacy-declaration/w/dataprotection/"
            i18n="@@footer.privacyPolicy"
          >
            Privacy Policy
          </a>
        </nav>
        <p class="copyright">© {{ year }} SICK AG</p>
      </div>
    </footer>`,
  styles: [
    `
      .footer-content {
        align-items: center;
        display: flex;
        flex-direction: row;
        gap: var(--syn-spacing-x-large);
        justify-content: space-between;
        padding: var(--syn-spacing-large) var(--syn-spacing-2x-large);
      }

      .copyright {
        color: var(--syn-typography-color-text);
        font: var(--syn-body-small-bold);
        margin: 0;
      }

      .link-wrapper {
        display: flex;
        gap: var(--syn-spacing-large);
        justify-content: center;
        list-style: none;
        margin: 0;
        padding: 0;
      }

      @container (max-width: 768px) {
        .link-wrapper {
          flex-direction: column;
          gap: var(--syn-spacing-small);
        }

        .footer-content {
          align-items: flex-start;
          flex-direction: column;
          padding: var(--syn-spacing-large) var(--syn-spacing-medium);
        }
      }
    `,
  ],
})
export class FooterComponent {
  year = new Date().getFullYear();
}
